export const PLAY_FIRST_YOUTUBE_VIDEO = 'PLAY_FIRST_YOUTUBE_VIDEO';
export const PLAY_FIRST_YOUKU_VIDEO = 'PLAY_FIRST_YOUKU_VIDEO';
export const PLAY_ALL_YOUTUBE_VIDEOS = 'PLAY_ALL_YOUTUBE_VIDEOS';
export const SET_SEEK_TO_ZERO_OF_SLIDE = 'SET_SEEK_TO_ZERO_OF_SLIDE';